import abstractModel from "../../core/MercatelyModel";

let resource = '/api/v1/teams';

const model = abstractModel(resource);

model.getAllForInbox = async (params = {}) => {
  return model.get(params, { path: `${resource}/all_inbox` });
};

export default model;
